/* eslint-disable @typescript-eslint/no-explicit-any */
import { DashboardRequest } from '@/types/action-plan/DashboardRequest';
import { InternalAxiosRequestConfig } from 'axios';
import type { ActionPlanApiRequestOptions } from '@/configs/actionPlanV2ApiOrigin';
import request from '../../base-service';
import {
  DeleteCongViecRequest,
  DeleteMultipleCongViecRequest,
  EditCongViecsRequest,
} from '@/types/action-plan/ActionPlan/EditCongViecsRequest';
import { SetStateApprovedRequest, SetHoTroApprovedRequest } from '@/types/action-plan/ActionPlan/SetStateApprovedRequest';
import { CloneDuAnRequest } from '@/types/action-plan/CloneDuAnRequest';
import type { ApiResponse } from '@/types/base';
import type { TimCongViecDuAnData, TimCongViecDuAnRequest } from '@/types/action-plan/TimCongViecDuAn';
import type {
  LoadTongQuanCongViecData,
  LoadTongQuanCongViecRequest,
} from '@/types/action-plan/LoadTongQuanCongViec';
import { EditCongViecResult } from '@/types/action-plan/ActionPlan/EditCongViecResult';
import { normalizeEditCongViecsRequestForApi } from '@/utils/dateOnlyForApi';

const baseUrl = '/v1';
export const congviecduanApi = {
  /**
   * POST: lấy dữ liệu dashboard dự án
   */
  //DashboardController
  loadCongViecByDuAn: (model: DashboardRequest) => {
    return request.post(`${baseUrl}/congviec/loadcongviecbyduan`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig);
  },
  cloneCongViecTemp: (model: CloneDuAnRequest) => {
    return request.post(`${baseUrl}/congviec/cloneCongViecTemp`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig);
  },
  chitiet: (model: DashboardRequest, options?: ActionPlanApiRequestOptions) => {
    return request.post(`${baseUrl}/congviec/chitiet`, model, {
      ...options,
      authorization: true,
    } as InternalAxiosRequestConfig);
  },

  /** POST: cập nhật hoàn thành trong ngày. `state: 'hoanthanh'` bật, `state: null` bỏ đánh dấu. */
  updateHoanThanhTrongNgay: (model: { congViecID: string; phanHe: string; state: string | null }) => {
    return request.post(`${baseUrl}/congviec/updateHoanThanhTrongNgay`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig);
  },

  /** POST: tìm công việc dự án (TenCongViec contains). */
  timCongViecDuAn: (model: TimCongViecDuAnRequest) => {
    return request.post<ApiResponse<TimCongViecDuAnData>>(
      `${baseUrl}/congviec/search`,
      model,
      {
        authorization: true,
      } as InternalAxiosRequestConfig
    );
  },

  /**
   * POST: tổng quan công việc — load tất cả dự án một request hoặc tìm kiếm (keyword).
   */
  loadTongQuanCongViec: (model: LoadTongQuanCongViecRequest) => {
    return request.post<ApiResponse<LoadTongQuanCongViecData>>(
      `${baseUrl}/congviec/loadtongquancongviec`,
      model,
      {
        authorization: true,
      } as InternalAxiosRequestConfig
    );
  },
  editcongviecs: (model: EditCongViecsRequest) => {
    return request.post<ApiResponse<EditCongViecResult>>(
      `${baseUrl}/congviec/editcongviecs`,
      normalizeEditCongViecsRequestForApi(model),
      {
        authorization: true,
      } as InternalAxiosRequestConfig
    );
  },
  xoacongviec: (model: DeleteCongViecRequest) => {
    return request.post<ApiResponse<boolean>>(`${baseUrl}/congviec/xoacongviec`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig);
  },
  xoanhieucongviec: (model: DeleteMultipleCongViecRequest) => {
    return request.post<ApiResponse<boolean>>(`${baseUrl}/congviec/xoanhieucongviec`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig);
  },
  setStateApproved: (model: SetStateApprovedRequest) => {
    return request.post(`${baseUrl}/congviec/setStateApproved`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig);
  },
  setHoTroApproved: (model: SetHoTroApprovedRequest) => {
    return request.post(`${baseUrl}/congviec/setHoTroApproved`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig);
  },
  /** GET: lấy lịch sử công việc/dự án. Truyền id (id công việc) qua query. */
  loadHistory: (id: string) => {
    return request.get(`${baseUrl}/congviec/loadhistory`, {
      params: { id },
      authorization: true,
    } as InternalAxiosRequestConfig);
  },
  // Checklist APIs
  addChecklist: (model: any) => {
    return request.post(`${baseUrl}/congviec/checklist/add`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig);
  },
  updateChecklist: (model: any) => {
    return request.post(`${baseUrl}/congviec/checklist/update`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig);
  },
  removeChecklist: (model: any) => {
    return request.post(`${baseUrl}/congviec/checklist/remove`, model, {
      authorization: true,
    } as InternalAxiosRequestConfig);
  },
};
